export const requiredSelect = (value?: string) => value !== 'none';
